import { useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SET_AUDIO_URL: 'SET_AUDIO_URL',
  SET_LOADING: 'SET_LOADING',
}

const initialState = {
  reAudioUrl: null,
  isReLoadingAudio: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_LOADING:
      return {
        ...state,
        isReLoadingAudio: action.value,
      }
    case ActionType.SET_AUDIO_URL:
      return {
        ...state,
        reAudioUrl: action.value,
        isReLoadingAudio: false,
      }
    default:
      return state
  }
}

export default function useTextToSpeech() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()

  const commonDispatch = useDispatch()

  const handleAlertError = () => {
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }

  const fetchAudio = (id, langId) => {
    dispatch({ type: 'SET_LOADING', value: true })
    effects.apis
      .checkAudioExists({ notificationId: id, langId: langId })
      .then((response) => {
        dispatch({
          type: 'SET_AUDIO_URL',
          value: response.audioUrl,
        })
      })
      .catch(() => handleAlertError())
  }

  const handleFetchAudio = (id, langId) => {
    fetchAudio(id, langId)
  }

  return {
    state,
    handleFetchAudio,
  }
}
